// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3N9KC","tableContainer":"styles_tableContainer__1FLVx","loader":"styles_loader__1w3qW"};